import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  Tabs,
  Tab,
  Form,
  Stack,
  InputGroup,
  FormControl,
} from 'react-bootstrap';
import classes from './changePasswordModal.module.scss';
import { Icon, CountDown, Button } from 'lb-components';
import { EyeIcon, EyeSlashIcon } from '../../../assets/icons';
import { Api, Hook, i18n } from 'lb-store';
import _ from 'lodash';

export const ChangePasswordModal = ({ onCancel, onSuccess, ...props }) => {
  const Alert = Hook.UseAlert();
  /*UseGuest*/
  const guest = Hook.UseGuest();

  /*ცვლადები*/
  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  /*  დამატებითი ცვლადები*/
  const [showPassword, setShowPassword] = useState(false);
  /*შეცდომები*/
  const [errors, setErrors] = useState({
    password: '',
    rePassword: '',
  });
  const change = () => {
    let err = {};
    if (!password) {
      err['password'] = i18n.t('გთხოვთ, შეავსოთ ველი');
    }

    if (!rePassword) {
      err['rePassword'] = i18n.t('გთხოვთ, შეავსოთ ველი');
    }
    if (_.size(err)) {
      setErrors({ ...errors, ...err });
      return;
    }

    if (password !== rePassword) {
      Alert.open({
        message: i18n.t('პაროლები არ ემთხვევა'),
      });
    } else {
      let params = {
        act: 'recoveryPassword',
        pass1: password,
        pass2: rePassword,
      };

      Api.Guest.Recovery(params, loader).then((response) => {
        if (response.status) {
          onCancel();
          Alert.open({
            message: i18n.t('პაროლი შეიცვალა წარმატებით'),
          });
        } else {
          Alert.open({
            message: response.data.desc,
          });
        }
      });
    }
  };
  return (
    <Modal
      contentClassName={classes.signInModal}
      onHide={onCancel}
      {...props}
      draggable
    >
      <Modal.Header closeButton>
        <Modal.Title className={classes.title}>პაროლის შეცვლა</Modal.Title>
      </Modal.Header>
      <Modal.Body className={classes.body}>
        <Form
          className={classes.form}
          onSubmit={(e) => {
            e.preventDefault();
            change();
          }}
        >
          <Form.Group className={classes.formGroup}>
            <Form.Label>პაროლი</Form.Label>
            <div
              style={{
                flex: 1,
                display: 'flex',
                position: 'relative',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Form.Control
                type={!showPassword ? 'password' : 'text'}
                isInvalid={errors.password !== ''}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrors({ ...errors, password: '' });
                }}
              />
              <Icon
                style={{
                  position: 'absolute',
                  right: '25px',
                }}
                Icon={!showPassword ? EyeSlashIcon : EyeIcon}
                height='20px'
                native
                width='20px'
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <div style={{ color: 'red', fontSize: '0.875em' }}>
              {errors.password}
            </div>
          </Form.Group>

          <Form.Group className={classes.formGroup}>
            <Form.Label>გაიმეორეთ პაროლი</Form.Label>
            <div
              style={{
                flex: 1,
                display: 'flex',
                position: 'relative',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Form.Control
                type={!showPassword ? 'password' : 'text'}
                isInvalid={errors.rePassword !== ''}
                value={rePassword}
                onChange={(e) => {
                  setRePassword(e.target.value);
                  setErrors({ ...errors, rePassword: '' });
                }}
              />
              <Icon
                style={{
                  position: 'absolute',
                  right: '25px',
                }}
                Icon={!showPassword ? EyeSlashIcon : EyeIcon}
                height='20px'
                native
                width='20px'
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            <div style={{ color: 'red', fontSize: '0.875em' }}>
              {errors.rePassword}
            </div>
          </Form.Group>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <Button
              variant={'success'}
              type='submit'
              style={{ marginRight: '2rem' }}
            >
              შეცვლა
            </Button>
            <Button variant={'secondary'} onClick={onCancel}>
              გაუქმება
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

ChangePasswordModal.propTypes = {
  show: PropTypes.bool,
  centered: PropTypes.bool,
  onCancel: PropTypes.func,
};
ChangePasswordModal.defaultProps = {
  show: true,
  centered: true,
  initialTab: 'password'
};
